import React, { useState } from "react";
import axios from "axios";
import { Button } from "globalComponents";
import FileUploader from "globalComponents/FileUploader";
import { SignedImage, SignedLink } from "globalComponents/SignedFile";
import { errorHandler } from "globalResources/util";
import { imgExtensions } from "globalResources/constants";
import { useParams } from "react-router-dom";
import styled from "styled-components";
import { getTheme } from "Theme";
import moment from "moment";
import { useDispatch } from "react-redux";
import { addNotification } from "store/slices/uiSlice";
const theme = getTheme();

const Main = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${theme.MANILLA};
  padding: 10px 35px;
  margin-top: auto;
  width: 100%;
  gap: 10px;
`;

const TextArea = styled.textarea`
  border: solid;
  border-radius: 5px;
  border-color: ${theme.INPUT_BORDER};
  min-height: 100px;
`;

const Preview = styled.a`
  font-size: 18px;
  font-weight: 800;
  color: ${theme.BUTTON_COLOR};
  border-radius: 20px;
  overflow: scroll;
`;

const Images = styled.div`
  display: flex;
  flex-direction: row;
  overflow: hidden;
  width: 640px;
  padding: 5px;
  gap: 15px;
`;

const Image = styled.img`
  width: 200px;
  object-fit: contain;
`;

const Container = styled.div`
  background-color: ${theme.SECONDARY_COLOR};
  border-radius: 10px;
  padding: 10px;
`;

const ButtonRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
`;

const FileUploadButton = styled.div`
  width: 50%;
  margin: auto;
`;

const NoteButton = styled.div`
  width: 50%;
  margin: auto;
`;

const BugNoteInput = ({ fetchBug }) => {
  const dispatch = useDispatch();
  const [inputValue, setInputValue] = useState("");
  const [files, setFiles] = useState([]);
  const { id } = useParams();

  const isImage = (file) => {
    const type = file.substring(file.lastIndexOf(".") + 1).toUpperCase();
    if (imgExtensions.includes(type)) return true;
    return false;
  };

  const addNoteHandler = () => {
    axios
      .patch(`/bug/${id}/note`, { note: inputValue, files })
      .catch((err) => {
        const { message } = errorHandler(err);
        dispatch(addNotification({ type: "error", message }));
      })
      .then(() => {
        setInputValue("");
        fetchBug(); // Reordered to prevent a no-work error thrown when submitting.
      });
  };

  return (
    <Main>
      <TextArea
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
      ></TextArea>{" "}
      {files.length > 0 ? (
        <Container>
          <Preview>
            {files.map((file) => {
              if (!isImage(file)) {
                let temp = file.split("/");
                return (
                  <SignedLink
                    component={Preview}
                    file={file}
                    key={file}
                    target="_blank"
                  >
                    {temp[temp.length - 1]}
                  </SignedLink>
                );
              }
              return null;
            })}
          </Preview>
          <Images>
            {files.map((file) => {
              if (isImage(file)) {
                return <SignedImage component={Image} file={file} key={file} />;
              }
              return null;
            })}
          </Images>
        </Container>
      ) : null}
      <ButtonRow>
        <FileUploadButton>
          <FileUploader
            hidePreview={true}
            label="Upload Files"
            namePrefix={`${moment().format("MM/DD/YYYY-hh:mm")}-`}
            folder="bugreport"
            onKey={(key) => setFiles((old) => old.concat([key]))}
          />
        </FileUploadButton>

        <NoteButton>
          <Button style={{ height: "35.5px" }} onClick={addNoteHandler}>
            Add Note
          </Button>
        </NoteButton>
      </ButtonRow>
    </Main>
  );
};

export default BugNoteInput;
